import type { ApiGenericResponse, CreateCustomOrderPayload } from '../../typings'

export function createCustomOrderAction(payload: CreateCustomOrderPayload): Promise<ApiGenericResponse<unknown>> {
  const formData = new FormData()

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value instanceof File ? value : String(value))
    }
  })
  const { api } = useApi()

  return api.post<ApiGenericResponse<unknown>>('/v2/custom-service-requests', formData)
}
